import { useEffect } from 'react';
import { ApiGet } from './Function';

export default function Test() {
  useEffect(() => {
    GetData();
  }, []);

  async function GetData() {
    //const response = await ApiGet('http://172.30.1.76:3000/monitoring/anseong/robotic-welding-machine');
    const response = await fetch('http://172.30.1.76:3000/monitoring/anseong/robotic-welding-machine', {
      method: 'GET',
    });
    console.log(response);
    if (response !== null && response.ok) {
      const json = await response.json();
      console.log(json);
    }
  }

  return <div>Test Page</div>;
}